import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ISession } from '../../../models/session';
import { map, first, tap } from 'rxjs/operators';
import { SessionBase } from '../session-base';

@Component({
  template: `
  <plugins-list class="wrapper-content" [session]="session"></plugins-list>
  `
})
export class SessionsFeaturesComponent extends SessionBase implements OnInit {
  constructor(private route: ActivatedRoute, private router: Router) {
    super();
  }
  ngOnInit() {
    super.getSession(this.route.parent.data);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/features/features.component.ts